import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { useParams } from "react-router-dom";
import AppBar from "../Common/AppBar";
import Copyright from "../Common/Copyright";
import Drawer from "../Common/Drawer";
import Title from "../Common/Title";
import FormGroup from "@mui/material/FormGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Cookies from 'js-cookie';

const defaultTheme = createTheme();

export const IssueEditor = ({ token }) => {
    const { id_issue } = useParams();
    const [Open, setOpen] = React.useState(false);
    const [Issue, setIssue] = React.useState({
        title: "",
        description: "",
        acl: { cs: false, eu: false, in: false },
      });
    const [IDSolution, setIDSolution] = React.useState();
    const [SolutionSteps, setSolutionSteps] = React.useState([]);

    React.useEffect(() => {
        const loadIssue = async () => {
            if (id_issue !== "new") {
                // Load the issue currently being edited
                const issueResponse = await fetch(
                    `${process.env.REACT_APP_API_URL}/issue/get/${id_issue}`, 
                    {
                        method: "GET",
                        headers: {
                            "Token": token
                        }
                })
                .then((response) => response.json())
                .then((data) => {
                    setIssue({
                        title: data.title,
                        description: data.description,
                    });
                    const aclData = data.acl ? data.acl.split(",") : [];
                    setIssue((prevIssue) => ({
                        ...prevIssue,
                        acl: {
                            cs: aclData.includes("cs"),
                            eu: aclData.includes("eu"),
                            in: aclData.includes("in"),
                        },
                    }));
                    setIDSolution(data.id_solution);
                }).catch((error) => console.error("Error fetching issue:", error));

                const solutionResponse = fetch(
                `${process.env.REACT_APP_API_URL}/solution/issue/get/${id_issue}`, 
                {
                    method: "GET",
                    headers: {
                        "Token": token
                    }
                })
                .then((response) => response.json())
                .then((data) => setSolutionSteps(data.solution_steps))
                .catch((error) => console.error("Error fetching solution:", error));              
            }
        };
        loadIssue();
      }, [id_issue]);

    /*
     * Event Handlers
     */
    const handleIssue = (event) => {
        const { name, value } = event.target;
        setIssue((prevIssue) => ({ ...prevIssue, [name]: value }));
    };

    const handleSolutionStep = (index, event) => {
        const solutionStepsNew = [...SolutionSteps];
        solutionStepsNew[index].step_sequence = index + 1;
        solutionStepsNew[index].step_description = event.target.value;
        setSolutionSteps(solutionStepsNew);
    };

    const handleACL = (event) => {
        const { name, checked } = event.target;
        setIssue((prevIssue) => ({
          ...prevIssue,
          acl: {
            ...prevIssue.acl,
            [name]: checked,
          },
        }));
      };

    /*
     * SolutionStep Buttons
     */
    const addSolutionStep = () => {
        const newStep = {
            stepDescription: "",
            stepSequence: SolutionSteps.length + 1,
        };
        setSolutionSteps([...SolutionSteps, newStep]);
    };

    const delete_solutionStep = (index) => {
        const newSteps = SolutionSteps.filter((_, i) => i !== index);
        setSolutionSteps(newSteps);
    };

    const getStringACL = () => {
        return Object.entries(Issue.acl)
            .filter(([_, value]) => value)
            .map(([key, _]) => key)
            .join(",");
    }

    /*
     * Page Buttons
     */
    const saveIssue = () => {
        let idIssueNext, idSolutionNext;

        if (id_issue === "new") {
            fetch(`${process.env.REACT_APP_API_URL}/issues/max/id_issue`, {
                method: "GET", 
                headers: {
                    "Content-Type": "application/json", 
                    "Token": token
                }
            })
            .then(response => response.json())
            .then(idIssueMax => {
                idIssueNext = idIssueMax + 1;
                return fetch(`${process.env.REACT_APP_API_URL}/solutions/idmax`, {
                    method: "GET", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }
                });
            })
            .then(response => response.json())
            .then(idSolutionMax => {
                idSolutionNext = idSolutionMax + 1;
                return fetch(`${process.env.REACT_APP_API_URL}/issue/add/${idIssueNext}`, {
                    method: "POST", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }, 
                    body: JSON.stringify({
                        id_solution: idSolutionNext, 
                        title: Issue.title, 
                        description: Issue.description, 
                        acl: getStringACL()
                    })
                });
            })
            .then(() => {
                return fetch(`${process.env.REACT_APP_API_URL}/solution/add/${idSolutionNext}`, {
                    method: "POST", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }, 
                    body: JSON.stringify(SolutionSteps)
                });
            })
            .then(() => {
                console.log("Created issue...", idIssueNext);
                window.location.href = `/console/structured/issue/${idIssueNext}`;
            })
            .catch(error => {
                console.error("Error creating issue:", error);
            });

        } else {
            fetch(`${process.env.REACT_APP_API_URL}/issue/set/${id_issue}`, {
                method: "POST", 
                headers: {
                    "Content-Type": "application/json", 
                    "Token": token
                }, 
                body: JSON.stringify({
                    title: Issue.title, 
                    description: Issue.description, 
                    acl: getStringACL()
                })
            })
            .then(() => {
                return fetch(`${process.env.REACT_APP_API_URL}/solution/delete/${IDSolution}`, {
                    method: "DELETE", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }
                });
            })
            .then(() => {
                return fetch(`${process.env.REACT_APP_API_URL}/solution/add/${IDSolution}`, {
                    method: "POST", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }, 
                    body: JSON.stringify(SolutionSteps)
                });
            })
            .then(() => {
                console.log("Saved changes...", id_issue);
                window.location.reload();
            })
            .catch(error => {
                console.error("Error saving changes:", error);
            });
        }
    };

    const deleteIssue = () => {
        if (id_issue === "new") {
            console.log("Cancelled issue creation...");
            window.location.href = "/console/structured";
        } else {
            fetch(`${process.env.REACT_APP_API_URL}/issue/delete/${id_issue}`, {
                method: "DELETE", 
                headers: {
                    "Content-Type": "application/json", 
                    "Token": token
                }
            })
            .then(() => {
                return fetch(`${process.env.REACT_APP_API_URL}/solution/delete/${IDSolution}`, {
                    method: "DELETE", 
                    headers: {
                        "Content-Type": "application/json", 
                        "Token": token
                    }
                });
            })
            .then(() => {
                console.log("Deleted issue...", id_issue);
                window.location.href = "/console/structured";
            })
            .catch(error => {
                console.error("Error deleting issue:", error);
            });
        }
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box sx={{ display: "flex" }}>
                <CssBaseline />
                <AppBar open={Open} toggleDrawer={() => setOpen(!Open)} />
                <Drawer open={Open} toggleDrawer={() => setOpen(!Open)} />
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === "light"
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: "100vh",
                        overflow: "auto",
                    }}
                >
                    <Toolbar />
                    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                        <Grid container spacing={3}>
                            {/* Issue Form */}
                            <Grid item xs={12} md={6}>
                                <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                                    <Title>Issue Information</Title>
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        id="title"
                                        label="Title"
                                        name="title"
                                        value={Issue.title}
                                        onChange={handleIssue}
                                    />
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        id="description"
                                        label="Description"
                                        name="description"
                                        multiline
                                        rows={4}
                                        value={Issue.description}
                                        onChange={handleIssue}
                                    />
                                    {/* ACL checkboxes */}
                                    <FormGroup row>
                                        <FormControlLabel control={<Checkbox name="cs" checked={Issue.acl.cs} onChange={ handleACL } />} label="Customer Service" />
                                        <FormControlLabel control={<Checkbox name="eu" checked={Issue.acl.eu} onChange={ handleACL } />} label="End User" />
                                        <FormControlLabel control={<Checkbox name="in" checked={Issue.acl.in} onChange={ handleACL } />} label="Installer" />
                                    </FormGroup>
                                    <Grid container spacing={2}>
                                        {/* Save Changes Button */}
                                        <Grid item>
                                            <Button
                                                onClick={saveIssue}
                                                variant="contained"
                                                color="primary"
                                            >
                                                Save Changes
                                            </Button>
                                        </Grid>
                                        {/* Delete Issue Button */}
                                        <Grid item>
                                            <Button
                                                onClick={deleteIssue}
                                                variant="contained"
                                                color="error"
                                            >
                                                Delete Issue
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            {/* Solution Steps */}
                            <Grid item xs={12} md={6}>
                                <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                                    <Title>Solution Steps</Title>
                                    {SolutionSteps.map((step, index) => (
                                        <Box key={index} sx={{ mb: 2 }}>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                id={`step-${index}`}
                                                label={`Step ${index + 1}`}
                                                name={`step-${index}`}
                                                multiline
                                                rows={2}
                                                value={step.step_description}
                                                onChange={(e) => handleSolutionStep(index, e)}
                                            />
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => delete_solutionStep(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    ))}
                                    <Button onClick={addSolutionStep} variant="contained">
                                        Add Step
                                    </Button>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Copyright sx={{ pt: 4 }} />
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default IssueEditor;
